<template>
  <div
    id="special"
    :class="`match-sport-color-${match.idSport}`"
    v-if="match">
    <div class="grid-top">
      <div class="grid-top-left">
        <match-header
          :id-sport="match.idSport"
          :id-display="match.idDisplay"
          :id-tournament="match.idTournament"
          :period-time="periodTime"
        />
        <match-info
          :id-sport="match.idSport"
          :teams="match.teams"
          :status="match.status"
        />
        <scout-events
          :id-match="match.id"
          v-if="match.hasScout"
        />
      </div>
      <div class="grid-top-right">
        <stream-player
          :id-match="match.id"
          :index="0"
          v-if="match.hasStream"
        />
        <scout
          :class="{ hidden: match.hasScout && match.hasStream }"
          :id-match="match.id"
          :index="0"
          v-show="match.hasScout && !match.hasStream"
        />
        <error-message
          :message="match.mediaErrorMessage"
          :class="{ middle: !match.hasScout }"
          v-if="match.mediaErrorMessage"
        />
      </div>
    </div>
    <div class="grid-bottom">
      <match-bets
        :id-sport="match.idSport"
        :id-match="match.id"
        :match-betting-status="match.bettingStatus"
        :match-status-period="match.status.period"
      />
    </div>
  </div>
</template>

<script>
import { each } from 'lodash';
import ErrorMessage from '@/components/common/error-message/ErrorMessage.vue';
import Scout from '@/components/common/scout/Scout.vue';
import StreamPlayer from '@/components/common/stream-player/StreamPlayer.vue';
import MatchHeader from './MatchHeader.vue';
import MatchInfo from './MatchInfo.vue';
import ScoutEvents from './ScoutEvents.vue';
import MatchBets from './MatchBets.vue';

export default {
  name: 'Special',
  components: {
    ErrorMessage,
    MatchHeader,
    MatchInfo,
    ScoutEvents,
    Scout,
    StreamPlayer,
    MatchBets,
  },
  computed: {
    match() {
      let match;

      // Stream match (stream has highest priority)
      let loop = true;
      const sports = this.$store.getters.activeSports;
      each(sports, (sport) => {
        if (!loop) return;

        const sportMatches = this.$store.getters.getStreamMatches(sport.id);
        if (sportMatches.length) {
          [match] = sportMatches;
          loop = false;
        }
      });

      // Scout match
      if (!match) {
        each(sports, (sport) => {
          if (!loop) return;

          const sportMatches = this.$store.getters.getScoutMatches(sport.id);
          if (sportMatches.length) {
            [match] = sportMatches;
            loop = false;
          }
        });
      }

      return match;
    },
    mediaErrorMessage() {
      return this.match ? this.match.mediaErrorMessage : '';
    },
    periodTime() {
      if (this.match.idSport === 21 && this.match.status.overs) {
        return `${this.match.status.overs}o`;
      }

      return this.match.status.periodTime;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

#special {
  float: left;
  width: 100%;
}

.grid-top {
  height: 55vh;
}

.grid-bottom {
  height: 40vh;
}

.grid-top-left,
.grid-top-right {
  position: relative;
  float: left;
  height: 100%;
  border-left: 1px solid $row-color-border;
  border-right: 1px solid $row-color-border;
}

.grid-top-left {
  width: 44.9%;
}

.grid-top-right {
  width: 55.1%;
  overflow: hidden;
}
</style>
